<template>
    <UiModal title="Şedinta s-a terminat!" subtitle="Şedinta anulata" :buttons="buttons" buttonsStyle="col" @newAppointment="newAppointment" @close="$emit('close')">
        <template slot="body"> 
            <div class="content__heading content__heading--center">
                Ne pare rău, <span>specialistul</span> nu s-a putut alatura sesiunii.
            </div>
            <div class="content"> 
                Din păcate specialistul dvs. nu s-a putut conecta la timp în sesiune.<br><br>
                În urmă acestui inconvenient, platforma <span>NEXYO</span> va returna ședințele utilizate înapoi în contul dvs.<br><br>
                Va mulțumim pentru înțelegere. <br>
            </div>
            <div class="content__spacer"></div>
        </template>
    </UiModal>
</template>
<script>
import UiModal from "@/components/ui/Modal";
import { mapGetters } from "vuex";
import { mapActions } from "vuex";

export default {
  components: {
    UiModal,
  },
  data: function () {
    return {
      buttons: [
        {
          event: "newAppointment",
          text: "Programare noua",
          style: "gradient",
        },
        {
          event: "close",
          text: "Meniul principal",
        },
      ],
    };
  },
  methods:{
    newAppointment(){
        this.$router.push('/'+ localStorage.getItem('role') +'/appointments');
    }
  },
  computed: {
    ...mapGetters({
      specialist: "anytimeMeeting/otherUser",
    }),
    currentDate: function () {
      return moment().format("LL");
    },
  },
};
</script>
<style lang="scss" scoped>
.content__info {
  margin-bottom: 10px;
}

.link:hover {
  text-decoration: underline;
  cursor: pointer;
}

//feedback

    ::v-deep .feedback{ //targets child components ** very useful
        display: flex;
        flex-direction: column;

        &__heading{
            font-weight: 500;
            font-size: 18px;
            line-height: 20px;
            width: 100%;
            margin-top: 30px;

            &--center{
                text-align: center;
            }

            span {
                color: $color-primary;
            }
        }

        &__star-group{
            flex-direction: row-reverse;
            display: flex;
            font-size: 40px;
            justify-content: space-between;
            max-width: 280px;
            width: 280px;
            color: rgba($color-main-text, 0.25);
            margin: 35px auto 0px auto;

            i{
                cursor: pointer;
            }

            i.active{
                color: #FED44C;
            }

            i:hover, i:hover ~ *{
                color: #FED44C;
            }
        }

        &__textarea{
            background: #FFFFFF;
            box-sizing: border-box;
            box-shadow: 0 3px 3px -2px rgba(0,0,0,0.2), 0 3px 4px 0 rgba(0,0,0,0.14), 0 1px 8px 0 rgba(0,0,0,0.12);
            width: 95%;
            min-height: 80px;
            outline: none;
            padding: 10px;
            border: 1px solid rgba($color-main-text, 0.25);
            margin: 35px auto 0px auto;

            &:focus{
                border: 1px solid #07EBD0;
            }

            &::placeholder{
                opacity: 0.25;
            }
        }

        &__validation{
            font-family: 'Roboto', sans-serif;
            font-size: 12px;
            line-height: 20px;
            color: $color-danger;
            margin: 10px 2.5% 10px 2.5%;
            visibility: hidden;

            &--visible{
                visibility: visible;
            }
        }
    }
</style>